// React
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';

class AppBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banners: [],
    };
  }

  componentDidMount() {
    this.getBannerElement();
  }

  // conditionally renders Application banner
  getBannerElement = () => {
    // assign banner via switch statement
    const bannerElement = (() => {
      switch (true) {
        default:
          return null;
      }
    })();

    if (bannerElement) this.addBanner(bannerElement);
  };

  addBanner = bannerElement => {
    let newBanners = this.state.banners;
    newBanners.push(bannerElement);
    this.setState({ banners: newBanners });
  };

  // TO-DO add ability to pop specific banners
  hideBanner = () => {
    let newBanners = this.state.banners;
    newBanners.shift();
    this.setState({ banners: newBanners });
  };

  resetBanners = () => {
    this.setState({ banners: [] });
  };

  goTo = url => {
    window.location.href = url;
  };

  render() {
    const { banners } = this.state;
    return banners[0] || null;
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(AppBanner);
